import { useMutation, useQuery } from "@tanstack/react-query";
import {
  getNextMeeting,
  verifyMeeting,
  getZoomServerConfig,
  ZoomServerConfig,
  verifyDoctorMeeting,
} from "../services/api/meeting";
import { doctorToken } from "../services/api/booking";

export const useGetNextMeeting = (eventUuid: string = "") => {
  return useQuery({
    queryKey: ["getNextMeeting"],
    queryFn: () => getNextMeeting(eventUuid),
    enabled: Boolean(eventUuid),
  });
};

export const useVerifyMeeting = () => {
  return useMutation({
    mutationFn: ({
      bookingId,
      healthCardLastDigits,
    }: {
      bookingId: string;
      healthCardLastDigits: string;
    }) => verifyMeeting(bookingId, healthCardLastDigits),
  });
};

export const useVerifyDoctorMeeting = () => {
  return useMutation({
    mutationFn: ({
      token,
    }: {
token: string;
    }) => verifyDoctorMeeting(token),
  });
};

export const useDoctorToken = () => {
  return useMutation({
    mutationFn: ({
      bookingId,
    }: {
      bookingId: string;
    }) => doctorToken(bookingId),
  });
};

export const useGetZoomServerConfig = () => {
  return useMutation({
    mutationFn: ({ token }: ZoomServerConfig) =>
      getZoomServerConfig({
        token,
      }),
  });
};
